import { action, makeObservable, observable } from 'mobx';

import { EntryTranslationData } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';
import { EntryTranslationStatus, Locale } from 'chaika-enums';
import { TranslationList } from '@patient/store/entry/TranslationList';
import { EntryTranslation } from '@patient/store/entry/EntryTranslation';

export class EntryTranslationList extends List<EntryTranslation, EntryTranslationData> {
    public static Name = 'entryTranslation' as const;

    @observable public selectedTranslation: Locale = Locale.Ru;
    @observable public translationList = new TranslationList();

    protected readonly identifiableFieldName: string = 'locale';

    public constructor(params?: EntryTranslationData[]) {
        super(params);
        makeObservable(this);
    }

    @action
    public setSelectedTranslation(locale: Locale): void {
        this.selectedTranslation = locale;
    }

    @action
    public resetStatus(): void {
        this.forEach(it => it.updateStatus(EntryTranslationStatus.InProgress));
    }

    protected create(params: EntryTranslationData): EntryTranslation {
        return new EntryTranslation(params);
    }
}
